import React, {  useState } from 'react';
import { UnAuthorizedLayout } from '../Layouts/UnAuthorizedLayout';
import { useAppDispatch } from "../../Store/hooks";
import { fetchingUserDetails, setIsAuthenticated, setUserDetails } from "../../Store/authSlice";
import { useNavigate, Link } from 'react-router-dom';
import { loginSchema } from '../../Components/Validation';
import { useFormik } from 'formik';
import { PostApiMethod } from '../../Utils/ApiService';
import { TextField } from '../../Components/Common';
import { colors, colorUtils } from '../../Utils/colors';
import { showNotification } from '../../Store/notificationSlice';

const initialValues = {
    username: "",
    password: "",
    rememberMe: true,
}

const LoginPage = () => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const formik = useFormik({
        initialValues,
        validationSchema: loginSchema,
       onSubmit: async (values) => {
  dispatch(fetchingUserDetails(true));
  setLoading(true);

  try {
    const payload = {
      email: values.username,
      password: values.password,
      rememberMe: values.rememberMe,
    };

    const res = await PostApiMethod('auth/login', payload);
    console.log("res", res);

    if (res.status === 200) {
      const data = res.data.data;
      window.localStorage.setItem("accessToken", data.accessToken);
      window.localStorage.setItem("login", "true");
      dispatch(setIsAuthenticated(true));
      dispatch(setUserDetails(data));
      navigate('/dashboard');
    } else {
      dispatch(showNotification({ message: 'Invalid username or password', type: 'error' }));
    }
  } catch (error) {
    console.log("Login error", error);
    dispatch(showNotification({ message: 'Invalid username or password', type: 'error' }));
  } finally {
    setLoading(false); 
    dispatch(fetchingUserDetails(false)); 
  }
       }
    });

    const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        formik.setFieldValue(name, value);
        formik.setFieldTouched(name, true, false);
    };

    const buttonStyle = {
        background: colors.primary.gradient,
        border: 'none',
        borderRadius: '12px',
        padding: '0.875rem 1.5rem',
        fontSize: '1rem',
        fontWeight: '600',
        textTransform: 'uppercase' as const,
        letterSpacing: '0.5px',
        transition: 'all 0.3s ease',
        position: 'relative' as const,
        overflow: 'hidden',
        color: colors.neutral.white,
        width: '100%'
    };

    const spinnerStyle = {
        display: 'inline-block',
        width: '20px',
        height: '20px',
        border: `3px solid ${colorUtils.withOpacity(colors.neutral.white, 0.3)}`,
        borderRadius: '50%',
        borderTopColor: colors.neutral.white,
        animation: 'spin 1s ease-in-out infinite',
        marginRight: '0.5rem'
    };

    return (
        <UnAuthorizedLayout>
            <form onSubmit={formik.handleSubmit} className="w-100">
                <TextField
                    name="username"
                    label="Email Address"
                    type="email"
                    value={formik.values.username}
                    onChange={handleFieldChange}
                      onBlur={formik.handleBlur} 
                    placeholder="Enter your email address"
                    error={formik.errors.username}
                    touched={formik.touched.username}
                    disabled={loading}
                    required
                    autoComplete="email"
                    size="md"
                    variant="default"
                />

                <TextField
                    name="password"
                    label="Password"
                    type="password"
                    value={formik.values.password}
                    onChange={handleFieldChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter your password"
                    error={formik.errors.password}
                    touched={formik.touched.password}
                    disabled={loading}
                    required
                    autoComplete="current-password"
                    size="md"
                    variant="default"
                    showPasswordToggle={true}
                />

                <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="form-check">
                        </div>
                        <Link
                            to="/forgot-password"
                            className="text-decoration-none fw-semibold"
                            style={{ color: colors.primary.main }}
                        >
                            Forgot Password?
                        </Link>
                    </div>
                </div>

                <button
                    type="submit"
                    className="btn w-100"
                    disabled={loading}
                    style={buttonStyle}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = `0 10px 20px ${colors.shadow.primary}`;
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                    }}
                >
                    {loading ? (
                        <>
                            <span style={spinnerStyle}></span>
                            Signing In...
                        </>
                    ) : (
                        'Sign In'
                    )}
                </button>

                <div className="text-center mt-4">
                    <p className="mb-0 text-muted">
                        Don't have an account?{' '}
                        <Link
                            to="/signup"
                            className="text-decoration-none fw-semibold"
                            style={{ color: colors.primary.main }}
                        >
                            Sign up
                        </Link>
                    </p>
                </div>
            </form>
        </UnAuthorizedLayout>
    );
};

export default LoginPage;
